import { NgModule } from '@angular/core';
import { SynclogService } from './synclog.service';
import { SynclogBackend } from './synclog.backend';

@NgModule({
  providers: [SynclogService, SynclogBackend],
})
export class SynclogModule {}
